document.addEventListener('DOMContentLoaded',()=>{
  let timer;
  const showToast=(message)=>{
    let toast=document.querySelector('[data-toast]');
    if(!toast){
      toast=document.createElement('div');
      toast.className='o38-toast';
      toast.setAttribute('data-toast','');
      document.body.appendChild(toast);
    }
    toast.textContent=message;
    toast.classList.add('is-show');
    clearTimeout(timer);
    timer=setTimeout(()=>toast.classList.remove('is-show'),2200);
  };

  const refreshCart=async()=>{
    try{
      const r=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{credentials:'same-origin'});
      const cart=await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    }catch(e){}
  };

  document.addEventListener('click',async(e)=>{
    const btn=e.target.closest('[data-add-to-cart]');
    if(!btn)return;
    e.preventDefault();
    const id=Number(btn.dataset.variantId);
    if(!id||btn.disabled)return;
    const old=btn.textContent;
    btn.disabled=true;btn.textContent='…';
    try{
      const r=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({items:[{id,quantity:1}]})
      });
      if(!r.ok)throw new Error('cart');
      await refreshCart();
      btn.textContent='✓';
      showToast('Adicionado ao carrinho ✓');
    }catch(err){
      showToast('Não foi possível adicionar.');
    }finally{
      setTimeout(()=>{btn.textContent=old;btn.disabled=false},1200);
    }
  });

  refreshCart();
});

/* OPEN 38 — intro de entrada da página inicial V10 */
document.addEventListener('DOMContentLoaded',()=>{
  const intro=document.querySelector('[data-open38-intro]');
  if(!intro)return;

  const html=document.documentElement;
  const key='open38:intro:shown:v2';

  /* Exibe uma vez por sessão para não repetir em cada navegação interna. */
  try{
    if(sessionStorage.getItem(key)==='1'){
      intro.remove();
      return;
    }
    sessionStorage.setItem(key,'1');
  }catch(e){}

  html.classList.add('o38-intro-lock');

  /* Open cai primeiro, 38 depois; então há um pequeno momento de pausa. */
  window.setTimeout(()=>{
    intro.classList.add('is-settled');
  },2350);

  window.setTimeout(()=>{
    intro.classList.add('is-finished');
  },3150);

  window.setTimeout(()=>{
    intro.classList.add('is-leaving');
    html.classList.remove('o38-intro-lock');
  },3550);

  window.setTimeout(()=>{
    intro.remove();
  },4450);
});


/* OPEN 38 V11 — quantity promotion 1 / 2 / 3 */
document.addEventListener('DOMContentLoaded',()=>{
  const productRoot=document.querySelector('[data-open38-product]');
  if(!productRoot)return;

  const cards=[...productRoot.querySelectorAll('[data-bundle-qty]')];
  const qtyInput=productRoot.querySelector('[data-open38-quantity]');
  const variantSelect=productRoot.querySelector('[data-open38-variant]');

  const shopCurrency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'JPY';
  const locale=document.documentElement.lang||'pt-BR';

  const formatMoney=(cents)=>{
    try{
      return new Intl.NumberFormat(locale,{
        style:'currency',
        currency:shopCurrency,
        maximumFractionDigits:shopCurrency==='JPY'?0:2
      }).format(cents/100);
    }catch(e){
      return (cents/100).toFixed(2);
    }
  };

  const refreshBundlePrices=()=>{
    if(!variantSelect)return;
    const option=variantSelect.options[variantSelect.selectedIndex];
    const unitPrice=Number(option?.dataset?.price||0);

    cards.forEach(card=>{
      const qty=Number(card.dataset.bundleQty||1);
      const priceEl=card.querySelector(`[data-bundle-price="${qty}"]`);
      if(priceEl&&unitPrice){
        priceEl.textContent=formatMoney(unitPrice*qty);
      }
    });

    const mainPrice=productRoot.querySelector('[data-product-main-price]');
    if(mainPrice&&unitPrice)mainPrice.textContent=formatMoney(unitPrice);
  };

  cards.forEach(card=>{
    card.addEventListener('click',()=>{
      const qty=Number(card.dataset.bundleQty||1);
      cards.forEach(other=>{
        const selected=other===card;
        other.classList.toggle('is-selected',selected);
        other.setAttribute('aria-pressed',selected?'true':'false');
      });
      if(qtyInput)qtyInput.value=qty;
    });
  });

  if(variantSelect){
    variantSelect.addEventListener('change',refreshBundlePrices);
  }

  refreshBundlePrices();
});
